import React from 'react';

export type StatusTone = 'success' | 'pending' | 'danger' | 'muted' | 'review';

export function StatusMark({
  tone,
  children
}: {
  tone?: StatusTone | '';
  children: React.ReactNode;
}) {
  if (children == null || children === '' || children === '—') return <span>—</span>;
  return (
    <span className={`status-mark${tone ? ` status-mark--${tone}` : ''}`}>
      <i className='status-mark-dot' aria-hidden />
      {children}
    </span>
  );
}
